import styled from 'styled-components';

import Flex1 from '../ui/Flex1';
import ScheduleCellBgStyle, { ScheduleCellBgProps } from '../components/ScheduleCellBgStyle';

import { LAST_ROW_OFFSET } from './constants';

const BORDER_COLOR = 'rgba(0, 0, 0, 0.08)';

export type ScheduleCellProps = {
  leftBorder?: boolean;
  bottomBorder?: boolean;
  columnsCount?: number;
  isLast?: boolean;
} & ScheduleCellBgProps;

const ScheduleCell = styled(Flex1)<ScheduleCellProps>`
  ${ScheduleCellBgStyle}
  flex-direction: row;
  border-right: 1px solid ${BORDER_COLOR};
  border-left: ${({ leftBorder }): number => (leftBorder ? 1 : 0)}px solid ${BORDER_COLOR};
  border-bottom: ${({ bottomBorder }): number => (bottomBorder ? 1 : 0)}px solid ${BORDER_COLOR};
  padding-left: 2px;
  padding-right: 2px;
  ${({ columnsCount }): string => (columnsCount ? `width: ${100 / columnsCount}%;` : '')};
  padding-bottom: ${(props): number => (props.isLast ? LAST_ROW_OFFSET : 0)}px;
  overflow: hidden;
`;

export default ScheduleCell;
